import { render } from "./DangerTriangleFullIcon.vue?vue&type=template&id=509cd205"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DangerTriangleFullIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "509cd205"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('509cd205', __exports__)) {
    api.reload('509cd205', __exports__)
  }
  
  module.hot.accept("./DangerTriangleFullIcon.vue?vue&type=template&id=509cd205", () => {
    api.rerender('509cd205', render)
  })

}


export default __exports__